import { I18n } from '@lingui/core'

import type { VariantAttribute } from 'views/containers/browser/ProductVariantsAttributesContainer'

const VARIANT_CODE_PACKAGE_SIZE = 'package_size'
const VARIANT_CODE_COLOR_NUMBER = 'color_number'

function getLabel(variantAttribute: VariantAttribute, i18n: I18n): string {
  switch (variantAttribute.variant_attribute) {
    case VARIANT_CODE_PACKAGE_SIZE:
      return i18n._('variantAttributes.label.package_size')

    case VARIANT_CODE_COLOR_NUMBER:
      return i18n._('variantAttributes.label.color_number')

    default:
      return variantAttribute.label.trim()
  }
}

export default function generateCartSubtitleFromVariantAttributes(
  i18n: I18n,
  pharmaFormLabel: string,
  variantAttributes?: VariantAttribute[]
): string {
  const attributes: string[] = []
  let packageSize = ''

  if (variantAttributes?.length) {
    variantAttributes.forEach((variantAttribute: VariantAttribute) => {
      variantAttribute.label = getLabel(variantAttribute, i18n)
      if (variantAttribute.variant_attribute !== VARIANT_CODE_PACKAGE_SIZE) {
        const labelAndValue =
          variantAttribute.label + ': ' + variantAttribute.value
        attributes.push(labelAndValue)
      } else {
        packageSize = variantAttribute.label + ': ' + variantAttribute.value
      }
    })
  }

  attributes.push(packageSize)
  attributes.push(pharmaFormLabel)

  return attributes.filter((it: string) => !!it).join(' | ')
}
